import { render, staticRenderFns } from "./LabelsForm.vue?vue&type=template&id=36ce26d1&"
import script from "./LabelsForm.vue?vue&type=script&lang=js&"
export * from "./LabelsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports